<template>
  <div class="mapbox aspect-video border" :id="uuid"></div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'Map',
  mounted() {
    this.loadMap();
  },
  data() {
    return {
      map: null,
      uuid: uuidv4(),
    };
  },
  methods: {
    async loadMap() {
      const mapboxModule = await import('mapbox-gl');
      const mapboxgl = mapboxModule.default; // Ensure proper module handling
      await import('mapbox-gl/dist/mapbox-gl.css'); // Lazy load CSS

      mapboxgl.accessToken = 'pk.eyJ1IjoidXJiYW5jaXR5bWd0IiwiYSI6ImNtNjJ0NGo3OTBzNW0ybHNld3hrNTNxeWIifQ.4gfcL6jldgw-1l5YvISJ0A';

      this.map = new mapboxgl.Map({
        container: this.uuid,
        style: 'mapbox://styles/mapbox/streets-v12',
        center: [parseFloat(this.lng), parseFloat(this.lat)],
        zoom: 12,
      });

      new mapboxgl.Marker()
        .setLngLat([this.lng, this.lat])
        .addTo(this.map);
    },
  },
  props: {
    lat: {
      required: true,
    },
    lng: {
      required: true,
    }
  },
};
</script>
